import styled from "@emotion/styled";
import React from "react";
import QuestionWrapper from "./QuestionWrapper";

interface Props {
  children: React.ReactNode;
}

const QuestionGroup = (props: Props, ref: React.Ref<HTMLDivElement>) => {
  return <QuestionGroup.Styled ref={ref}>{props.children}</QuestionGroup.Styled>;
};

QuestionGroup.Styled = styled.div`
  display: block;
  flex-grow: 1;
  margin-bottom: 12px;

  ${QuestionWrapper} + ${QuestionWrapper} {
    margin-top: 10px;
  }
`;

export default React.forwardRef(QuestionGroup);
